"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/esnext.iterator.some.js");
async function faqFilterService() {
  let filtertype = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'apis';
  let filterterm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let faqDataSet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let faqTitle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  const generateFaqSlugTitle = str => str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
  // function to filter based on filtertype if in case for future
  function tagsValueArray(x, filtertype) {
    let tempArr = [];
    x.tags.map(z => {
      if (z.name === filtertype) {
        tempArr = z.value;
      }
    });
    return tempArr;
  }
  //to filter only common type of faq
  function tagsValue(x, filtertype) {
    let tempArr;
    x.tags.map(z => {
      if (z.name === filtertype) {
        tempArr = z.value[0];
      }
    });
    return tempArr;
  }
  if (filterterm) {
    let filterResults;
    if (filtertype === 'common') {
      filterResults = faqDataSet.filter(x => x.tags && tagsValue(x, filtertype).includes(true));
    } else if (filtertype === 'topics') {
      filterResults = faqDataSet.filter(x => x.topics && !(generateFaqSlugTitle(x.title) === faqTitle) && filterterm.some(value => x.topics.includes(value)));
    } else {
      filterResults = faqDataSet.filter(x => x.tags && tagsValueArray(x, filtertype).includes(filterterm));
    }
    return filterResults;
  } else {
    // return faqDataSet;
  }
}
var _default = exports.default = faqFilterService;